module.exports = __webpack_public_path__ + "static/media/Gilroy-Medium-Italic.6b048550.woff";